import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import emailjs from 'emailjs-com';
import apiKeys from '../apikeys'
import Footer from './Footer'
import Articles from './Articles'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'

import '../Accueil.css'

// Firebase
import base from '../base'


class Accueil extends Component {
  state = {
    recettes: [],
    redirect:false,
    search: ''
    }

  componentDidMount(){
    //reference ds firebase

    this.ref = base.syncState(`/listeRecettes`,{
      context: this,
      state: 'recettes',
      queries: {
        orderByChild: "id",
        limitToLast: 3
      }
    })
  }
  
  componentWillUnmount () {
    //fermer la reference ds firebase
    //la connexion est terminée entre notre state et firebase
    base.removeBinding(this.ref)
  }

  handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

  handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
  }

  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
    
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

  compare = ( a, b ) => {
  if ( (a)[0].split("-")[1] < (b)[0].split("-")[1] ){
      return 1;
  }
  if ( (a)[0].split("-")[1] > (b)[0].split("-")[1] ){
      return -1;
  }
  return 0;
  }

  sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_g4nxmka',apiKeys.TEMPLATE_ID, e.target, apiKeys.USER_ID)
    .then(result => {
      alert('Message Sent, I\'ll get back to you shortly');
      },
      error => {
      alert( 'An error occured, Please try again');
      })
  }

   render () {  

    let articles = []
    Object
    .entries(this.state.recettes)
    .map(key => 
      articles.push(key)
    );
    articles.sort(this.compare)

    return (
      <>
        <Container fluid>
          <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                  <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                      <Col lg={3} md={6} sm={6} xs={12} className="nopadding">
                      <a href="/competiton/natation">
                        <div className="natation banner-image">
                          <div className="banner-text">
                            <p  className="banner-text">Natation</p>
                          </div>
                        </div>
                      </a>
                      </Col>
                      <Col lg={3} md={6} sm={6} xs={12} className="nopadding">
                      <a href="/competiton/nage-synchronisee">
                        <div className="synchronise banner-image">
                          <div className="banner-text">
                           <p className="banner-text">Natation Synchronisée</p>
                          </div>
                        </div>
                      </a>
                      </Col>

                      <Col lg={3} md={6} sm={6} xs={12} className="nopadding">
                      <a href="/cours">
                        <div className="enfant banner-image">
                          <div className="banner-text">
                            <p className="banner-text">Cours enfants et adultes</p>
                          </div>
                        </div>
                        </a>
                      </Col>

                      <Col lg={3} md={6} sm={6} xs={12} className="nopadding">
                      <a href="/formation/sauvetage">
                        <div className="sauvetage banner-image">
                          <div className="banner-text">
                            <p className="banner-text">Formation sauvetage sportif</p>
                          </div>
                        </div>
                        </a>
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                        <div className="inscription">
                        <h1 className="hline"><span>SAUTE le PAS</span></h1>  
                        <p>INSCRIPTION ET ACTIVITÉS</p>  
                        <div className="incription-link">
                        <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                          <a href="https://www.amilia.com/store/en/capn/shop/programs" className="btn btn-primary btn-blue-light">
                          TOUTES LES INFORMATIONS ICI
                          </a>
                        </Col>

                        </div>

                        </div>
                      </Col>
                      {((Object.keys(this.state.recettes).length !== 0)) &&
                        <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                          <div className="actu-content">
                            <h1 className="hline"><span>Actualités</span></h1>                   
                            <Articles details={articles}/>
                          </div>
                       </Col>
                        }
                      
                    </Row>
                  </Col>


              <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <Footer />
              </Col>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
  }

export default Accueil
